import {
  TPaymentByModel,
  TPaymentManualInput,
} from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const calculatePaymentInstallment = ({
  payload,
}: {
  payload: TPaymentManualInput | TPaymentByModel;
}) => {
  return API.post(`api/accommodation/calculations/payments/calculate`, payload).then(
    response => response?.data,
  );
};
